import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function Comparison() {
  const without = ['Aprendés por ensayo y error', 'Cometés los errores de todo principiante', 'No sabés si está bien hasta que te lo rechazan', 'Te quedás atrás mientras otros van al digital', 'Dependés de que alguien te enseñe'];
  const with_ = ['Sistema paso a paso probado', 'Evitás errores costosos desde el inicio', 'Sabés qué hacer en cada etapa', 'Dominás el flujo digital y CAD/CAM', 'Aprendés a tu ritmo, material completo'];
  return <section className="w-full px-4 py-10 bg-gray-50" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <div className="grid grid-cols-2 gap-3" data-id="element-50">
          <div className="bg-white p-4 rounded-xl shadow-sm border border-red-200" data-id="element-51">
            <h3 className="text-base md:text-lg font-bold text-red-600 mb-3 text-center" data-id="element-52">
              ❌ Sin el sistema
            </h3>
            <ul className="space-y-2" data-id="element-53">
              {without.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-54">
                  <XIcon className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-55" />
                  <span className="text-xs md:text-sm text-gray-700 leading-snug" data-id="element-56">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-white p-4 rounded-xl shadow-sm border border-green-200" data-id="element-57">
            <h3 className="text-base md:text-lg font-bold text-green-600 mb-3 text-center" data-id="element-58">
              ✅ Con el sistema
            </h3>
            <ul className="space-y-2" data-id="element-59">
              {with_.map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-60">
                  <CheckIcon className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" data-id="element-61" />
                  <span className="text-xs md:text-sm text-gray-700 leading-snug" data-id="element-62">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}